<app-modal
  [title]="'Extras' | trans:'extras/extras-modal/header/title'"
  maxWidth="1200px"
  minWidth="30%"
  width="fit-content"
  [compact]="true"
>
  <ng-template>
    <div class="extras-buttons-wrapper d-grid gap-12">
      <button
        class="button button--quick-action"
        (click)="tseDetailsModalComponent.open()"
        [disabled]="!isTseConnected"
        appTooltip
        [wrapHostForHover]="true"
        [hide]="isTseConnected"
        content="{{ 'No TSE is connected to this terminal.' | trans:'extras/extras-modal/buttons/tse.Tooltip' }}"
      >
        <i class="icon-webcash_tse-online"></i>
        {{ 'TSE' | trans:'extras/extras-modal/buttons/tse.Button' }}
      </button>

      <button
        class="button button--quick-action"
        [disabled]="!terminalParametersMap()[terminalParameterKeys.CASH_EC_TERMINAL_IP] || isEcStandalone"
        (click)="ecTerminalActionsModalComponent.open()"
      >
        <i class="ri-bank-card-2-line"></i>
        {{ 'EC' | trans:'extras/extras-modal/buttons/ec.Button' }}
      </button>

      @if (isEcSumUp && sumUpDevReader) {
        <button
          class="button button--quick-action"
          (click)="openSumUpPairing()"
        >
          <i class="ri-link"></i>
          {{ 'SumUp koppeln' | trans:'extras/extras-modal/buttons/sumUpPairing.Button' }}
        </button>
      }
    </div>

    <div class="separator"></div>

    <div class="extras-buttons-wrapper d-grid gap-12">
      <button
        class="button button--quick-action"
      >
        <span class="position-relative">
          <i class="ri-terminal-box-line"></i>
          <span class="status {{ workerStatusColorClass() }}"></span>
        </span>

        {{ 'Worker Status' | trans:'extras/extras-modal/buttons/workerStatus.Button' }}
      </button>

      <button
        class="button button--quick-action"
        (click)="toggleCustomerScreen()"
      >
        <span class="position-relative">
          <i class="ri-computer-line"></i>
          <span class="status {{ isCustomerScreenOnline() ? 'c-bg-ok-500' : 'c-bg-gray-500' }}"></span>
        </span>

        {{ 'Custmer Screen' | trans:'extras/extras-modal/buttons/customerScreen.Button' }}
      </button>
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ 'Cancel' | trans:'extras/extras-modal/cancel.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>

<app-terminal-tse-details-modal #tseDetailsModalComponent />
<app-ec-terminal-actions-modal #ecTerminalActionsModalComponent />

<app-modal
  #sumUpPairingModal
  [title]="'SumUp koppeln' | trans:'extras/extras-modal/sumup-pairing/header/title'"
  maxWidth="1200px"
  minWidth="30%"
  width="fit-content"
  [compact]="true"
>
  <ng-template>
    <app-form-control
      label="{{ 'SumUp pairing code' | trans:'extras/extras-modal/sumup-pairing-code.Label' }}"
    >
      <input
        type="text"
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"
        [(ngModel)]="sumUpPairingCode"
        placeholder="{{ 'Code from Virtual Solo' | trans:'extras/extras-modal/sumup-pairing-code.Placeholder' }}"
      >
      @if (sumUpReaderId) {
        <span helperTexts class="p3 c-t-gray-500">
          {{ 'Paired for this browser session' | trans:'extras/extras-modal/sumup-reader.Text' }}: {{ sumUpReaderId }}
        </span>
      }
    </app-form-control>
  </ng-template>
  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="sumUpPairingModal.close()"
      >
        {{ 'Cancel' | trans:'extras/extras-modal/cancel.Button' }}
      </button>
      <button
        class="button button--md button--primary text-uppercase"
        [disabled]="!sumUpPairingCode?.trim()"
        (click)="confirmSumUpPairing()"
      >
        {{ 'Confirm' | trans:'extras/extras-modal/sumup-pairing/confirm.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>
